<template>
  <v-autocomplete
    label="Select State(s)"
    v-bind="attributes"
    v-on="listeners"
    :items="usStates"
    outlined
    :loading="loading"
    clearable
    item-text="name"
    item-value="id"
    :error-messages="errorMessages"
  >
  </v-autocomplete>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState({
      usStates: state => state.usStates.list
    }),
    attributes () {
      return {
        multiple: this.isMultiple,
        ...this.$attrs
      }
    },
    listeners () {
      return {
        ...this.$listeners
      }
    }
  },

  props: {
    isMultiple: {
      type: Boolean,
      required: false,
      default: true
    },
    errorMessages: {
      type: [String, Array, Object],
      default () {
        return null
      }
    },
  },

  methods: {
    ...mapActions({
      getStates: 'usStates/getStates'
    })
  },
  mounted () {
    this.loading = true
    this.getStates({ page: 1 })
      .finally(() => { this.loading = false })
  }

}
</script>
